<template>
    <div>
        <SToolbar>
            <v-icon small class="mr-1">ic-20 ic-mediamanager ic-col-grey</v-icon>
            <v-toolbar-title>{{ $t('media_manager') }}</v-toolbar-title>
        </SToolbar>
        <MainView session-key="mm-main" height="var(--usable-height)" />
    </div>
</template>

<script>
import MainView from '@/components/media_manager/MainView.vue';

export default {
    name: 'MediaManagerView',
    components: {
        MainView,
    },
};
</script>
